import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Close from 'src/assets/icons/close.svg';

import { closeDisclaimer, setSelectedDisclaimer } from 'src/redux/configurator/actions';
import { openModalSelector } from 'src/redux/configurator/selectors';
import { DisclaimerContainer, DisclaimerContent, CloseButton, DisclaimerText } from './Disclaimer.styled';

const Disclaimer = ({ children, financeOptionsLeftPosition, infoButtonRef }) => {
  const dispatch = useDispatch();
  const ref = useRef(null);
  const openModals = useSelector(openModalSelector);

  useEffect(() => {
    const handleClickOutside = event => {
      if (openModals.disclaimer) {
        return;
      }

      if (ref.current && !ref.current.contains(event.target) && event.target !== infoButtonRef.current) {
        dispatch(closeDisclaimer());
        dispatch(setSelectedDisclaimer(null));
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [dispatch, infoButtonRef, openModals.disclaimer]);

  return (
    <DisclaimerContainer ref={ref} financeOptionsLeftPosition={financeOptionsLeftPosition}>
      <DisclaimerContent>
        <CloseButton
          type="button"
          data-testid="close"
          onClick={() => {
            dispatch(closeDisclaimer());
            dispatch(setSelectedDisclaimer(null));
          }}
        >
          <Close />
        </CloseButton>
        <DisclaimerText dangerouslySetInnerHTML={{ __html: children }}></DisclaimerText>
      </DisclaimerContent>
    </DisclaimerContainer>
  );
};

export default Disclaimer;
